import { pipe, prop } from 'ramda'
import { request } from 'shared/helpers/sagas'

export function launchSurveys (surveys) {
    const openSurvey = surveyId => request(
      `/v1/survey/${surveyId}/open?lang=en_us`,
      'PUT',
      {}
    )
    return Promise.all(surveys.map(pipe(prop('id'), openSurvey)))
  }
  
export function closeSurveys (surveys) {
    const closeSurvey = surveyId => request(`/v1/survey/${surveyId}/close?lang=en_us`,
      'PUT',
      {}
    )
    return Promise.all(surveys.map(pipe(prop('id'), closeSurvey)))
  }

export default{
    launchSurveys,
    closeSurveys
}